export default "__VITE_ASSET__CHPO5$pJ__"